import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Qué es exactamente un IUL?',
  answer: 'IUL significa Indexed Universal Life (Seguro de Vida Universal Indexado). Es una póliza de seguro de vida permanente que ofrece un beneficio por fallecimiento para proteger a tu familia, y al mismo tiempo acumula un valor en efectivo que crece basado en un índice del mercado (como el S&P 500), sin el riesgo de perder dinero si el mercado cae.'
}, {
  question: '¿Es muy caro obtener una póliza IUL?',
  answer: 'No necesariamente. Las pólizas IUL son flexibles y se diseñan a la medida de tu presupuesto y objetivos financieros. Puedes comenzar con aportaciones mensuales manejables e irlas ajustando con el tiempo.'
}, {
  question: '¿Cómo funciona el retiro libre de impuestos?',
  answer: 'El dinero que acumulas en tu IUL puede ser accedido a través de préstamos contra la póliza. Según las leyes fiscales actuales (IRS), los préstamos sobre seguros de vida no se consideran ingresos sujetos a impuestos, permitiéndote usar ese dinero para tu retiro sin pagar taxes.'
}, {
  question: '¿Qué pasa si me enfermo gravemente?',
  answer: "La mayoría de nuestras pólizas IUL incluyen 'Beneficios en Vida'. Esto significa que si sufres una enfermedad crónica, crítica o terminal (como un ataque al corazón, cáncer o derrame cerebral), puedes adelantar una parte del beneficio por fallecimiento para pagar gastos médicos o reemplazar tus ingresos mientras estás en vida."
}, {
  question: '¿Por qué agendar una llamada con un agente?',
  answer: 'Cada situación financiera es única. Un agente licenciado analizará tus ingresos, deudas, metas de retiro y necesidades familiares para diseñar una póliza estructurada correctamente. Una póliza mal estructurada puede no brindarte los beneficios fiscales y de crecimiento que buscas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 bg-brand-light" data-id="element-21">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-12" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-24">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-25">
            Resolvemos tus dudas sobre el Seguro de Vida Universal Indexado.
          </p>
        </div>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden" data-id="element-27">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-28">
                <span className="font-semibold text-brand-navy pr-4" data-id="element-29">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-30" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-31" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-32">
                <p className="text-gray-600 leading-relaxed" data-id="element-33">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}